import React from "react";

export const Logo = ({ className = "", dark = false, size = 30 }) => {
  const textColor = dark ? "#0A0F1A" : "#FFFFFF";
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="header-brand-logo">
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <path
          d="M4 15L16 5l12 10"
          stroke="#00C3A7"
          strokeWidth="2.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 14v11a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V14"
          stroke="#0D6EFD"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="13" y="18" width="6" height="8" rx="0.8" stroke="#00C3A7" strokeWidth="2" />
      </svg>
      <span
        className="font-extrabold tracking-tight leading-none"
        style={{ color: textColor, fontSize: size * 0.72 }}
      >
        ID-BAT<span style={{ color: "#0D6EFD" }}> PRO</span>
      </span>
    </div>
  );
};
